let noLoading = ["/customer/upload"];

let loading = ["loading_dg_page", "loading_dg_form_dialog",'loading_dg_alert_box'];
export default class Topic {
  constructor() {}

  loadingOpen(url) {
    if (noLoading.indexOf(url) == -1) {
      loading.forEach((key) => {
        Mirror.emit(`${key}_open`, url);
      });
    }
  }
  loadingClose(url) {
    loading.forEach((key) => {
      Mirror.emit(`${key}_close`, url);
    });
  }
  tipsOpen(url, res) {
    ["table_success_tips", "tips_dg_alert_box", "tips_dg_page", "tips_dg_form_dialog"].forEach((key) => {
      Mirror.emit(`${key}_open`, res, url);
    });
  }
  tipsClose(url, res) {
    ["table_success_tips", "tips_dg_alert_box", "tips_dg_form_dialog"].forEach((key) => {
      Mirror.emit(`${key}_close`, res, url);
    });
  }
}
